import React, {forwardRef, useImperativeHandle, useState} from 'react';
import { useForm } from 'react-hook-form';
import { statesLong } from "../config/utils";
import { getContactResponse } from "./miscFeeFunctions";
import Grid2 from "@mui/material/Grid2";
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Typography from "@mui/material/Typography";
import TextField from '@mui/material/TextField';
import { PatternFormat } from 'react-number-format';
import FormLabel from "@mui/material/FormLabel";
import {useSxStyles as sx} from "../styles/sxStyles";

const ContactInfo = forwardRef((props, ref) => {
    const internalAgency = props.internalAgency;
    const posPayments = props.posPayments;
    const court = props.court;
    const { register, getValues } = useForm();
    const [phoneVal, setPhoneVal] = useState(null);
    const [zipVal, setZipVal] = useState(null);

    useImperativeHandle(ref, () => ({
        getContactInfo() {
            const form = getValues();
            return getContactResponse(form, phoneVal, zipVal, internalAgency, posPayments);
        }
    }));

    return (<>
        <Grid2
            size={{
                xs: 12,
                md: 6
            }}>
            <FormControl
                required
                fullWidth
                {...register('payorName')}
                >
            <FormLabel shrink={true} htmlFor='payorName' sx={sx.inputLabel}>Payor Name</FormLabel>
            <TextField
                name="payorName"
                variant='outlined'
                fullWidth
                slotProps={{
                    htmlInput: { id: 'payorName', maxLength: 100, sx: sx.textbox }
                }}
            />
            </FormControl>
        </Grid2>
        <Grid2
            size={{
                xs: 12,
                md: 6
            }}>
            <FormControl
                fullWidth
                {...register('partyName')}
                >
                <FormLabel shrink={true} htmlFor='partyName' sx={sx.inputLabel}>Party Name</FormLabel>
            <TextField
                name="partyName"
                variant='outlined'
                fullWidth
                slotProps={{
                    htmlInput: { id: 'partyName', maxLength: 256, sx: sx.textbox }
                }}
            />
            </FormControl>
        </Grid2>
        <Grid2
            size={{
                xs: 12,
                md: 6
            }}>
        <FormControl
            required={!internalAgency}
            fullWidth
            {...register('address')}
            >
            <FormLabel shrink={true} htmlFor='address' sx={sx.inputLabel}>Billing Address</FormLabel>
            <TextField
                name="address"
                variant='outlined'
                fullWidth
                slotProps={{
                    htmlInput: { id: 'address', sx: sx.textbox}
                }}
            />
        </FormControl>
        </Grid2>
        <Grid2
            size={{
                xs: 12,
                md: 6
            }}>
            <FormControl
                required={!internalAgency}
                fullWidth
                {...register('city')}
                >
                <FormLabel Shrink={true} htmlFor='city' sx={sx.inputLabel}>City</FormLabel>
            <TextField
                name="city"
                variant='outlined'
                fullWidth
                slotProps={{
                    htmlInput: { id: 'city', sx:sx.textbox}
                }}
            />
            </FormControl>
        </Grid2>
        <Grid2
            size={{
                xs: 12,
                md: 6
            }}>
            <FormControl
                required={!internalAgency}
                fullWidth
                {...register('state')}
                >
                <FormLabel shrink={true} htmlFor='state' sx={sx.inputLabel}>State</FormLabel>
                <Select
                    name='state'
                    native
                    variant='outlined'
                    fullWidth
                    sx={{height: '2rem'}}
                    inputProps={{id: 'state'}}
                >
                    <option key='none' value=''></option>
                    { statesLong.map((_state) => (
                        <option key={_state.key} value={_state.value}>{_state.value}</option>
                    ))}
                </Select>
            </FormControl>
        </Grid2>
        <Grid2
            size={{
                xs: 12,
                md: 6
            }}>
            <FormControl
                required={!internalAgency}
                fullWidth
                {...register('zip')}
                >
                <FormLabel htmlFor={'zip'} shrink={true} sx={sx.inputLabel}>Billing Zip</FormLabel>
                <PatternFormat
                    name='zip'
                    id='zip'
                    customInput={TextField}
                    type='text'
                    autoComplete='off'
                    variant='outlined'
                    format="#####"
                    InputProps={{
                        style: sx.numberbox
                    }}
                    onValueChange={(values) => setZipVal(values)}
                />
            </FormControl>
        </Grid2>
        <Grid2
            size={{
                xs: 12,
                md: 6
            }}>
            <FormControl
                fullWidth
                {...register('email')}
            >
                <FormLabel shrink={true} htmlFor='email' sx={sx.inputLabel}>Email Address</FormLabel>
            <TextField
                name='email'
                variant='outlined'
                fullWidth
                slotProps={{
                    htmlInput: { id: 'email', sx: sx.textbox }
                }}
            />
            </FormControl>
        </Grid2>
        <Grid2
            size={{
                xs: 12,
                md: 6
            }}>
            <FormControl
                fullWidth
                {...register('phone')}
            >
                <FormLabel shrink={true} htmlFor='phone' sx={sx.inputLabel}>Phone Number</FormLabel>
                <PatternFormat
                    name='phone'
                    id='phone'
                    customInput={TextField}
                    type='text'
                    autoComplete='off'
                    variant='outlined'
                    format="(###) ###-####"
                    onValueChange={(values) => setPhoneVal(values)}
                    InputProps={{
                        style: sx.numberbox
                    }}
                />
            </FormControl>
        </Grid2>
        { court && court.requireContactInfo &&
            <Grid2 size={12} >
                <Typography component='div' variant='subtitle2' color='secondary'>
                    *The payor's name, address, and either email address or phone number are required
                </Typography>
            </Grid2>
        }
    </>);
})

export default ContactInfo;
